import React from 'react';
import { Clock, Shield, MapPin, Zap, Sparkles, BatteryCharging, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { poolBenefits, poolColors, processSteps } from '../data/poolInfo';

const iconMap = {
  clock: Clock,
  shield: Shield,
  'map-pin': MapPin,
  zap: Zap,
  sparkles: Sparkles,
  'battery-charging': BatteryCharging
};

const WhyFiberglass = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-orange-100 rounded-full mb-4">
            <span className="text-orange-700 font-semibold text-sm">The Fiberglass Advantage</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Why Choose Fiberglass?
          </h2>
          <p className="text-lg text-slate-600">
            Discover why fiberglass pools are the smart choice for Texas homeowners
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {poolBenefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <Card 
                key={index}
                className="border-2 border-slate-100 hover:border-cyan-400 hover:shadow-xl transition-all duration-300 bg-white"
              >
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg text-slate-900 mb-2">{benefit.title}</h3>
                      <p className="text-slate-600 text-sm">{benefit.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Installation Process */}
        <div>
          <h3 className="text-3xl font-bold text-slate-900 mb-8 text-center">
            Simple Installation Process
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {processSteps.map((item, idx) => (
              <div key={idx} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-full flex items-center justify-center mb-4 shadow-lg">
                    <span className="text-white font-bold text-2xl">{item.step}</span>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">{item.title}</h4>
                  <p className="text-slate-600 text-sm mb-2">{item.description}</p>
                  <span className="inline-block px-3 py-1 bg-cyan-100 text-cyan-700 rounded-full text-xs font-semibold">
                    {item.duration}
                  </span>
                </div>
                {idx < processSteps.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-cyan-400 to-blue-600 -translate-x-1/2"></div>
                )}
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-green-100 rounded-full">
              <CheckCircle className="w-5 h-5 text-green-600" />
              <span className="text-green-800 font-semibold">Total Installation: 1-2 Weeks from Start to Swim!</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyFiberglass;
